import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { PricingRuleAction } from '@cbridge-packages/pricing-rules';
import { RulesManagementAction, makeRuleRowModelAndState } from '@cbridge-modules/rules-management-page';

export const onLoadPricingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    PricingRuleAction.loadList.done,
  ),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result);
    return [
      RulesManagementAction.updateState({ ...initialState, rules: rows }),
    ];
  }),
);
